import { SwiperOptions } from 'swiper';

// https://swiperjs.com/swiper-api

interface ISwiperConfigs {
    [key: string]: SwiperOptions;
}

const defaultConfig: SwiperOptions = {
    breakpoints: {
        768: {
            slidesPerView: 1
        }
    }
};

export function getCarouselConfig(context, configName) {

    configurations[configName] = {
        ...configurations[configName],
        navigation: {
            nextEl: context.querySelector('.swiper-button-next'),
            prevEl: context.querySelector('.swiper-button-prev')
        },
        pagination: {
            el: context.querySelector('.swiper-pagination')
        }
    }

    return configurations[configName];
}

const configurations = {
    productPageCarousel: {
        slidesPerView: 1,
        navigation: {
            nextEl: '[data-config="productPageCarousel"] .swiper-button-next',
            prevEl: '[data-config="productPageCarousel"] .swiper-button-prev'
        },
        hashNavigation: {
            watchState: true
        },
        pagination: {
            el: '[data-config="productPageCarousel"] .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        spaceBetween: 30,
        loop: true,
    },
    productPageCarouselSingle: {
        slidesPerView: 1,
        navigation: {
            nextEl: '[data-config="productPageCarouselSingle"] .swiper-button-next',
            prevEl: '[data-config="productPageCarouselSingle"] .swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        spaceBetween: 30,
        centerInsufficientSlides: true,
        loop: false,
        breakpoints: {
            1200: {
                slidesPerView: 1
            }
        }
    },
    brandPageReviews: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="brandPageReviews"] .swiper-button-next',
            prevEl: '[data-config="brandPageReviews"] .swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true
        }
    },
    reviewPanel: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="reviewPanel"] .swiper-button-next',
            prevEl: '[data-config="reviewPanel"] .swiper-button-prev'
        },
    },

    brandPageProducts: {
        ...defaultConfig,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true
        },
        spaceBetween: 25
    },

    simpleAssociatedProducts: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="simpleAssociatedProducts"] .swiper-button-next',
            prevEl: '[data-config="simpleAssociatedProducts"] .swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        spaceBetween: 16,
        centerInsufficientSlides: true,
        slidesPerView: 4,
        slidesPerGroup: 1,
        breakpoints: {
            0: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 15,
                slidesPerGroup: 1
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 5,
                slidesPerGroup: 1
            }
        }
    },
    productPageSimpleAssociatedProducts: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="productPageSimpleAssociatedProducts"] .swiper-button-next',
            prevEl: '[data-config="productPageSimpleAssociatedProducts"] .swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        spaceBetween: 16,
        centerInsufficientSlides: true,
        slidesPerView: 2,
        slidesPerGroup: 1,
        breakpoints: {
            0: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 15,
                slidesPerGroup: 1
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 15,
                slidesPerGroup: 1
            }
        }
    },
    carouselVybeProducts: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="carouselVybeProducts"] .swiper-button-next',
            prevEl: '[data-config="carouselVybeProducts"] .swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        spaceBetween: 10,
        centerInsufficientSlides: true,
        slidesPerView: 5,
        slidesPerGroup: 1,
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 2,
                slidesPerGroup: 1
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 5,
                slidesPerGroup: 1
            },
            1200: {
                slidesPerView: 5,
                spaceBetween: 5,
                slidesPerGroup: 1
            }
        }
    },

    ajax: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="ajax"] .swiper-button-next',
            prevEl: '[data-config="ajax"] .swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        slidesPerView: 1,
        loop: true
    },
    quickview: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="quickview"] .swiper-button-next',
            prevEl: '[data-config="quickview"] .swiper-button-prev'
        },
        loop: true,
        sliderPerView: 1,
        breakpoints: {
            992: {
                slidesPerView: 2,
                spaceBetween: 5
            },
            768: {
                slidesPerView: 1
            }
        }
    },

    uspslider: {
        loop: true,
        autoplay: true,
        sliderPerView: 1
    },

    completeTheOutfit: {
        spaceBetween: 15,
        navigation: {
            nextEl: '[data-config="completeTheOutfit"] .swiper-button-next',
            prevEl: '[data-config="completeTheOutfit"] .swiper-button-prev'
        },
        slidesPerView: 2
    },

    rolexKeepExploring: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="rolexKeepExploring"] .swiper-button-next',
            prevEl: '[data-config="rolexKeepExploring"] .swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        spaceBetween: 15,
        centerInsufficientSlides: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 5,
                slidesPerGroup: 2
            }
        }
    },

    testimonialCarousel: {
        spaceBetween: 32,
        navigation: {
            nextEl: '[data-config="testimonialCarousel"] .swiper-button-next',
            prevEl: '[data-config="testimonialCarousel"] .swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        slidesPerView: 3,
        breakpoints: {
            1200: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 1
            }
        }
    },
    pdpImageThumbnails: {
        spaceBetween: 15,
        direction: 'vertical',
        navigation: {
            nextEl: '[data-config="pdpImageThumbnails"] .swiper-button-next',
            prevEl: '[data-config="pdpImageThumbnails"] .swiper-button-prev'
        },
        autoHeight: true,
        slidesPerView: 7
    },
    loopPdp: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        }
    },

    fiveProducts: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="fiveProducts"] .swiper-button-next',
            prevEl: '[data-config="fiveProducts"] .swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        spaceBetween: 15,
        centerInsufficientSlides: true,
        slidesPerView: 5,
        slidesPerGroup: 5,
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            1200: {
                slidesPerView: 5,
                slidesPerGroup: 5
            }
        }
    },
    threeProducts: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="threeProducts"] .swiper-button-next',
            prevEl: '[data-config="threeProducts"] .swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        spaceBetween: 15,
        centerInsufficientSlides: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 3
            }
        }
    },
    pdpCarousel: {
        ...defaultConfig,
        navigation: {
            nextEl: '[data-config="pdpCarousel"] .swiper-button-next',
            prevEl: '[data-config="pdpCarousel"] .swiper-button-prev'
        },
        pagination: {
            el: '[data-config="pdpCarousel"] .swiper-pagination',
            type: 'bullets'
        },
        spaceBetween: 15,
        centerInsufficientSlides: true,
        slidesPerView: 4,
        slidesPerGroup: 4,
        breakpoints: {
            0: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            1200: {
                slidesPerView: 4,
                slidesPerGroup: 4
            }
        }
    },
    categoryLinks: {
        slidesPerView: 11,
        spaceBetween: 0,
        freeMode: {
            enabled: true,
            sticky: false,
            momentumBounce: false
        },
        breakpoints: {
            0: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 5
            },
            1200: {
                slidesPerView: 7,
            },
            1600: {
                slidesPerView: 10,
            }
        }
    },
    categoryCarousel: {
        slidesPerView: 1.2,
        spaceBetween: 15,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: '[data-config="categoryCarousel"] .swiper-button-next',
            prevEl: '[data-config="categoryCarousel"] .swiper-button-prev'
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2
            },
            768: {
                slidesPerView: 2.2,
            },
            992: {
                slidesPerView: 3.2
            },
            1600: {
                slidesPerView: 4.2
            },
        }
    },
    brandLogoCarousel: {
        slidesPerView: 3,
        spaceBetween: 15,
        loop: true,
        navigation: {
            nextEl: '.brand-logo-carousel .swiper-button-next',
            prevEl: '.brand-logo-carousel .swiper-button-prev'
        },
        breakpoints: {
            0: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 7,
            },
            992: {
                slidesPerView: 9,
            },
            1200: {
                slidesPerView: 12,
            },
        }
    },
    carBrandLogoCarousel: {
        slidesPerView: 2,
        spaceBetween: 15,
        loop: true,
        slidesOffsetAfter: 0,
        navigation: {
            nextEl: '.brand-logo-carousel .swiper-button-next',
            prevEl: '.brand-logo-carousel .swiper-button-prev'
        },
        breakpoints: {
            0: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 5,
            },
            1200: {
                slidesPerView: 7,
            },
            1600: {
                slidesPerView: 8,
            },
        }
    },
    assocProdCarousel: {
      slidesPerView: 2.1,
      spaceBetween: 15,
      loop: false,
      centerInsufficientSlides: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        snapOnRelease: true,
        draggable: true
      },
      navigation: {
        nextEl: '.swiper--products .swiper-button-next',
        prevEl: '.swiper--products .swiper-button-prev'
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 3,
        },
        1600: {
          slidesPerView: 4,
        },
      }
    },
    assocProdCarouselTwo: {
        slidesPerView: 2.1,
        spaceBetween: 15,
        loop: false,
        centerInsufficientSlides: true,
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
            snapOnRelease: true,
            draggable: true
        },
        navigation: {
            nextEl: '.swiper--products .swiper-button-next',
            prevEl: '.swiper--products .swiper-button-prev'
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
            },
        }
    },
    pdpBlogs: {
      slidesPerView: 2,
      spaceBetween: 15,
      loop: false,
      centerInsufficientSlides: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        snapOnRelease: true,
        draggable: true
      },
      navigation: {
        nextEl: '.swiper--products .swiper-button-next',
        prevEl: '.swiper--products .swiper-button-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      }
    },
    appSplash: {
        ...defaultConfig,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },

        navigation: {
            nextEl: '.btn',
        },
        spaceBetween: 0,
    }
} as ISwiperConfigs;

export default configurations;
